import Divider       from "_components/atoms/divider";
import FetchMore     from "_components/atoms/fetchMoreLoader";
import VideoCardList from "_components/organisms/videoCardList";

import SectionHeader          from "../sectionHeader";
import { formatLiveSessions } from "../utils";

import useStyles from "./styles";

const component = ( { data, isLoading, isDepleted, fetchMore, list2 = [] } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.mainContainer }>

			<div
				className = { classes.sectionContainer }
			>
				<div className = { `${ classes.headerContainer }` }>
					<SectionHeader
						isCategoryPage
						sesstionList   = { data.sessions.slice ( 0, 3 ) }
						streamCount    = { data.streamCount }
						title          = { data.cardName }
						uniqueViews    = { data.uniqueViews }

					/>

					<Divider />
				</div>

				<VideoCardList
					cardType       = { "stream" }
					containerClass = { `${ classes.verticalSpacing } ${ classes.cardListContainer }` }
					list           = { formatLiveSessions ( [ ...data.sessions, ...list2 ] ) }
				/>

				<FetchMore
					fetchMore  = { fetchMore }
					isDepleted = { isDepleted }
					isLoading  = { isLoading }
				/>
			</div>

		</div>
	);
};

export default component;